<template>
  <div id="app">
    <canvas id="connections-effect-canvas" class="d-none d-xl-block" style="z-index: -1;"></canvas>
    <div v-if="user.isLogged === true || $route.name == 'autologin'">
      
      <router-view/>
    </div>
    <div v-else>
      <Login />
    </div>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'




import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {    
    Login,
  },
  computed: {
    ...mapState({
        user: state => state.User
    }),
    ...mapGetters('User', {
      fullName: 'fullName'
    })
  },
  methods: {
    ...mapActions('User', [
      'checkLogin','loadTvTerritorio'
    ])    
  },
  created: function() {
    this.checkLogin( isLogged => {
      if(isLogged) this.loadTvTerritorio();
    });
  }
}

</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
